



















































import {Vue,Component, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class';
import BtnDefault from '@/components/UI/BtnDefault.vue'
import ICopy from '@/components/icons/ICopy.vue'
import SupportDialog from '@/components/beta/SupportDialog.vue'

const newauth = namespace('newauth')
const dialog = namespace('dialog')

@Component({
  components: {
    BtnDefault,
    ICopy,
    SupportDialog,
  }
})
export default class FullError extends Vue {
  @newauth.Action('logout') protected logout: any
  @dialog.Getter('fullErrorShow') protected fullErrorShow: any
  @dialog.Getter('titleError') protected titleError: any
  @dialog.Getter('subtitleError') protected subtitleError: any
  @dialog.Getter('textContentError') protected textContentError: any
  @dialog.Getter('isCopyError') protected isCopyError: any
  @dialog.Getter('isBtnLogout') protected isBtnLogout: any
  @dialog.Getter('isBtnSupport') protected isBtnSupport: any
  @dialog.Getter('isBtnHome') protected isBtnHome: any
  @dialog.Mutation('SetFullErrorShow') protected SetFullErrorShow : any

  dialogSupport:boolean = false
  
  copy(value:string) {
    let area = document.createElement('textarea');
    document.body.appendChild(area);
    area.value = value;
    area.select();
    document.execCommand("copy");
    document.body.removeChild(area);
  }

  tryLogout() {
    // if(this.$route.name != 'NewAuth') {
    //   this.logout()
    // }
    this.$router.push({name:'Logout'})
    this.SetFullErrorShow(false)
  }
  goHome() {
    localStorage.removeItem('sw')
    if(this.$route.name != 'NewAuth') {
      this.$router.push({name:'NewAuth'})
    }
    this.SetFullErrorShow(false)
  }

}

